import { Box, Button, Grid } from "@mui/material";
import { IntegrationAddHeader } from "../../../headers/IntegrationAddHeader";
import { IntegrationType } from "~/operations";

interface ConfigurePreferencesProps {
  integrationType: IntegrationType;
  preferencesForm: React.ReactNode;
  onFinalizeSetup: () => Promise<void>;
}

export function ConfigurePreferences({
  integrationType,
  preferencesForm,
  onFinalizeSetup,
}: ConfigurePreferencesProps) {
  return (
    <Grid container>
      <Grid size={12}>
        <IntegrationAddHeader {...{ type: integrationType }} />
      </Grid>
      <Grid size={12}>
        <Box pb={10}>{preferencesForm}</Box>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button onClick={onFinalizeSetup} variant="contained" color="primary">
            Finalize setup
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}
